import { alertController, AlertOptions } from "@ionic/vue";
import { t } from "@/plugins/vue-i18n";

import { ObjectUnknown } from "@/types/functions";

type PopAlertConfirmParams = Omit<AlertOptions, "buttons"> & {
    handler?: {
        cancel?: (value?: any) => boolean | void | ObjectUnknown | Promise<boolean> | Promise<void> | Promise<ObjectUnknown>;
        ok?: (value?: any) => boolean | void | ObjectUnknown | Promise<boolean> | Promise<void> | Promise<ObjectUnknown>;
    },
    cancelText?: string;
    okText?: string;
};

type PopAlertOkParams = Omit<AlertOptions, "buttons"> & {
    handler?: (value?: any) => boolean | void | ObjectUnknown | Promise<boolean> | Promise<void> | Promise<ObjectUnknown>;
};

const popAlertConfirm = async (params: PopAlertConfirmParams, cypressId?: string): Promise<void> => {
    const alert = await alertController.create({
        ...params,
        buttons: [
            {
                role: 'cancel',
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                text: params.cancelText ?? t('button.no'),
                id: 'cancel-alert',
                handler: params.handler?.cancel ?? alertController.dismiss
            },
            {
                role: 'ok',
                text: params.okText ?? t('button.yes'),
                id: 'ok-alert',
                handler: params.handler?.ok
            }
        ]
    })

    alert.dataset.cy = cypressId
    if (!Array.isArray(alert.cssClass)) alert.cssClass += ' custom-alert'
    else alert.cssClass.push('custom-alert')

    await alert.present()
}

const popAlertOk = async (params: PopAlertOkParams, cypressId?: string): Promise<void> => {
    const alert = await alertController.create({
        ...params,
        buttons: [
            {
                role: 'ok',
                text: t('button.ok'),
                id: 'ok-alert',
                handler: params.handler ?? alertController.dismiss
            }
        ]
    })

    alert.dataset.cy = cypressId
    if (!Array.isArray(alert.cssClass)) alert.cssClass += ' custom-alert'
    else alert.cssClass.push('custom-alert')

    await alert.present()
}

export {
    popAlertConfirm,
    popAlertOk
}
